import '../sass/carousel.scss';

(() => {
    const $blocks = document.querySelectorAll('.carousel');

    $blocks?.forEach($block => {
        const $mediaCarousel = $block.querySelector('.carousel__media-carousel');
        const $textCarousel = $block.querySelector('.carousel__text-carousel');
        const $controlsPrevious = $block.querySelector('.carousel__controls--previous');
        const $controlsNext = $block.querySelector('.carousel__controls--next');
        const $videos = $block.querySelectorAll('.carousel__video');

        let players = [];

        const setCarouselHeight = () => {
            if (!$mediaCarousel) return;

            $mediaCarousel.style.height = `${Math.round($mediaCarousel.offsetWidth / 16 * 9)}px`;
        };

        const initVideos = () => {
            if (!$videos) return;

            $videos.forEach($video => {
                players.push(new Plyr($video));
            });
        };

        const initCarousels = () => {
            if (!$mediaCarousel) return;

            const mediaSwiper = new Swiper($mediaCarousel, {
                slidesPerView: 'auto',
                spaceBetween: 10,
                centeredSlides: true,
                keyboard: {
                    enabled: true,
                    onlyInViewport: true,
                },
                navigation: {
                    nextEl: $controlsNext,
                    prevEl: $controlsPrevious,
                },
            });

            if ($textCarousel) {
                const textSwiper = new Swiper($textCarousel, {
                    slidesPerView: 'auto',
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true
                    },
                    allowTouchMove: false,
                });

                mediaSwiper.controller.control = textSwiper;
            }

            mediaSwiper.on('slideChange', () => {
                if (!players) return;

                players.forEach(player => {
                    player.pause();
                });
            });
        };

        window.addEventListener('resize', setCarouselHeight);

        initVideos();
        initCarousels();
        setCarouselHeight();
    });
})();
